import { api } from "./api";

interface PayableCreateBody {
  title: string;
  amount: number;
  dueDate: string | Date;
  categoryId: Number;
  storeId: number | undefined;
  description?: string;
  recurrenceEnd?: string | Date;
  isRecurring?: boolean;
  recurrence?: string;
  status?: string;
}

interface CategoryPayableBody {
  name: string;
}
export const PayableCreate = async (body: PayableCreateBody): Promise<any> => {

  const { data } = await api.post("Payable/create", body);
  return data;
};

export const CategoryCreate = async (
  body: CategoryPayableBody
): Promise<any> => {
  const { data } = await api.post("Payable/create-category", body);
  return data;
};

export const CategoryList = async () => {
  const { data } = await api.get(`Payable/list-category`);
  return data;
};

export const PayableCreateStudent = async (
  body: PayableCreateBody
): Promise<any> => {
  const { data } = await api.post("student/payment/create", body);
  return data;
};

export const PayableMonth = async (params: { storeId: number | undefined }) => {
  const { data } = await api.get(`Payable/month`, { params });
  return data;
};

export const Payables = async () => {
  const { data } = await api.get(`Payable/payables`);
  return data;
};

export const Indicators = async (params: { storeId: number | undefined }) => {
  const { data } = await api.get(`Payable/indicators`, { params });
  return data;
};
const toISODate = (v?: string | Date) =>
  !v ? undefined : v instanceof Date ? v.toISOString().slice(0, 10) : v;

export const PayablesPaid = async (raw: {
  storeId: number | undefined;
  startDate?: string | Date;
  endDate?: string | Date;
  status?: string;
}) => {
  const params = {
    storeId: raw.storeId,
    startDate: toISODate(raw.startDate),
    endDate: toISODate(raw.endDate),
    status: raw.status,
  };
  const { data } = await api.get("Payable/payables-paids", { params });
  return data as { month: any[]; recurrence: any[]; countPaid: any[] };
};

export const Overdues = async (params: { storeId: number | undefined }) => {
  const { data } = await api.get(`Payable/overdues`, { params });
  return data;
};

export const Recurrence = async (params: { storeId: number | undefined }) => {
  const { data } = await api.get(`Payable/recurrence`, { params });
  return data;
};

export const payableUpadate = async (body: {
  id?: number;
  title?: string;
  amount?: number;
  dueDate?: string | Date;
  category?: string;
  storeId?: number | undefined;
  description?: string;
  recurrenceEnd?: string | Date;
  isRecurring?: boolean;
  recurrence?: string;
  status?: any;
  paymentDate?: Date;
}): Promise<any> => {
  const { data } = await api.put("Payable/update", body);
  return data;
};

export const categoryUpdate = async (body: {
  id?: number;
  name?: string;
}): Promise<any> => {
  const { data } = await api.put("Payable/update-category", body);
  return data;
};

export const payableUpadateRecurrence = async (body: {
  id?: number;
  title?: string;
  amount?: number;
  dueDate?: string | Date;
  category?: string;
  storeId?: number | undefined;
  description?: string;
  recurrenceEnd?: string | Date;
  isRecurring?: boolean;
  recurrence?: string;
  status?: any;
  paymentDate?: Date;
}): Promise<any> => {
  const { data } = await api.put("Payable/update-recurrence", body);
  return data;
};
